/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import Bridge, { VKBridgeSubscribeHandler } from "@vkontakte/vk-bridge";
import Api from "../api";
import { HealthCheckEvents } from "../api/types";

export type BridgeInvoke = <TPayload = void, TResponse = void>(
  eventName: string,
  payload?: TPayload
) => Promise<TResponse>;

export const isWebView = Bridge?.isWebView();

export const bridgeInvoke = <TPayload = void, TResponse = void>(
  eventName: string,
  payload?: TPayload
) => {
  const callbackEventName = `${eventName}Result`;
  let payloadEvent: any;

  return new Promise<TResponse>((resolve, reject) => {
    const handle: VKBridgeSubscribeHandler = (event) => {
      payloadEvent = event;
      if (!event.detail) return;
      // @ts-ignore
      if (event.detail.type === callbackEventName) {
        console.log("event.detail");
        console.log(event.detail);
        // @ts-ignore
        resolve(event.detail.data);
        Bridge.unsubscribe(handle);
      }
    };

    Bridge.subscribe(handle);
    // @ts-ignore
    Bridge.send(eventName, payload).catch((error) => {
      Api.healthCheckFor(HealthCheckEvents.vkBridgeErrors).sendFailure(
        JSON.stringify({
          eventName,
          payload,
          error,
        })
      );
      console.error(error);
      reject(error);
    });
  });
};
